<template>
  <div class="animated fadeIn change-pass">
    <i
      hidden
      class="ms-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card class="p-2" dark>
        <v-card-text class="text-center">
          لطفا کمی صبر کنید...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2 ps-2">تغییر رمز عبور</h4>
      </div>
      <hr class="mt-5" />
      <v-row style="margin-top: 50px">
        <v-col class="px-md-8 d-flex align-items-center">
          <div class="pass-notes">
          
            <p>رمز عبور انتخابی شما باید دارای مشخصه‌های زیر باشد:</p>
            <br />
            <p>
              <v-icon class="me-3">{{
                password.length > 7 ? "$BorderedCheck" : "$BorderedKey"
              }}</v-icon
              >حداقل 8 نویسه
            </p>
            <p>
              <v-icon class="me-3">{{
                has_uppercase ? "$BorderedCheck" : "$BorderedKey"
              }}</v-icon
              >دارای حروف بزرگ باشد
            </p>
            <p>
              <v-icon class="me-3">{{
                has_lowercase ? "$BorderedCheck" : "$BorderedKey"
              }}</v-icon
              >دارای حروف کوچک باشد
            </p>
            <p>
              <v-icon class="me-3">{{
                has_number ? "$BorderedCheck" : "$BorderedKey"
              }}</v-icon
              >دارای عدد باشد
            </p>
          </div>
        </v-col>
        <v-col class="px-md-8">
          <v-card class="pass-card">
            <h3 class="mt-3 mb-15">تغییر رمز عبور</h3>
            <v-text-field
              :append-icon="!showPass1 ? '$EyeOff' : '$EyeOn'"
              :type="showPass1 ? 'text' : 'password'"
              @click:append="showPass1 = !showPass1"
              v-model="oldPassword"
              class="mb-8"
              label="رمز عبور فعلی"
            ></v-text-field>
            <v-text-field
              :append-icon="!showPass2 ? '$EyeOff' : '$EyeOn'"
              :type="showPass2 ? 'text' : 'password'"
              @click:append="showPass2 = !showPass2"
              @input="passStrength"
              v-model="password"
              class="mb-9"
              label="رمز عبور جدید"
            ></v-text-field>
            <div v-if="password.length">
              <div class="d-flex justify-space-between pb-2 c-grey">
                <span :class="checkPersent == 25 ? 'red--text' : ''"
                  >رمز عبور ضعیف</span
                >
                <span :class="checkPersent == 100 ? 'teal--text' : ''"
                  >رمز عبور قوی</span
                >
              </div>
              <v-progress-linear
                :color="
                  checkPersent == 25
                    ? 'red'
                    : checkPersent == 100
                    ? '#12B8A1'
                    : '#FBC02D'
                "
                rounded
                :value="checkPersent"
                height="7"
                class="mb-10"
              ></v-progress-linear>
            </div>

            <v-text-field
              :append-icon="!showPass3 ? '$EyeOff' : '$EyeOn'"
              :type="showPass3 ? 'text' : 'password'"
              @click:append="showPass3 = !showPass3"
              v-model="repeatPassword"
              class="mb-3"
              label="تکرار رمز عبور جدید"
              hide-details=""
              @input="passStrength"
            ></v-text-field>
            <span
              v-if="repeatPassword && !checkPassword"
              class="float-right red--text"
              ><v-icon color="red">mdi-alert-circle-outline</v-icon> رمز عبور
              جدید را با دقت وارد کنید</span
            >
            <div class="text-right pt-6 mt-12">
              <v-btn
                class="purple-mainBtn"
                @click="changePassword()"
                :disabled="
                  isBusy ||
                  !checkPassword ||
                  !password ||
                  !oldPassword ||
                  !repeatPassword ||
                  checkPersent != 100
                "
                >ثبت رمز عبور جدید</v-btn
              >
            </div>
          </v-card>
        </v-col>
        
      </v-row>
    </v-card>
  </div>
</template>

<script>
import Axios from "axios"; // NOTE (IMPORT) to read the data from back_end of project
import md5 from "js-md5";

export default {
  data() {
    return {
      guide: false,
      password: "",
      repeatPassword: "",
      oldPassword: "",
      codeSent: false,
      activationCode: "",
      newPass: "",
      repeatNewPass: "",
      countdown: 60,
      sendAgainDisbaled: false,
      busy: false,
      isBusy: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      dialog: false,
      showPass1: false,
      showPass2: false,
      showPass3: false,
    };
  },
  computed: {
    checkPassword() {
      // NOTE (c-checkPass) to check that the password is not duplicate
      return this.password == this.repeatPassword ? true : false;
    },
    // NOTE this func check if the password has lowecase,uppercase and number
    passStrength() {
      this.has_number = /\d/.test(this.password);
      this.has_lowercase = /[a-z]/.test(this.password);
      this.has_uppercase = /[A-Z]/.test(this.password);
    },

    checkPersent() {
      let progress = 0;
      let total = 4;
      this.password.length > 7 ? progress++ : 1;
      this.has_uppercase ? progress++ : 1;
      this.has_lowercase ? progress++ : 1;
      this.has_number ? progress++ : 1;
      return parseInt((progress / total) * 100);
    },
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    changePassword() {
      if (
        this.has_number &&
        this.has_lowercase &&
        this.has_uppercase &&
        this.password.length > 7
      ) {
        this.dialog = true;
        // NOTE (m-changePassword) to change the password
        this.isBusy = true;
        Axios.post(
          this.baseUrl + "/ppkpms/user/changePassword",
          {
            password: md5(this.password),
            oldPassword: md5(this.oldPassword),
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            this.dialog = false;
            this.isBusy = false;
            this.password = "";
            this.repeatPassword = "";
            this.oldPassword = "";
            const title = (
              <div>
                <h5>ویرایش رمز</h5>
                <span>رمز شما با موفقیت تغییر کرد</span>
              </div>
            );
            this.toast(title, "success");
          })
          .catch((err) => {
            this.dialog = false;
            this.isBusy = false;
            this.toast(err.response.data, "error");
          });
      } else {
        this.toast(
          "لطفا جهت حفظ امنیت اطلاعات خود موارد خواسته شده را در رمز خود اعمال کنید",
          "error"
        );
      }
    },
  },
};
</script>

<style lang="scss">

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  border-bottom: 1px solid #c8ced3;
}

.myselect2 {
  width: 100%;
}
/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
.pass-card {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.13) !important;
  border-radius: 20px !important;
  padding: 20px 40px;
  text-align: center;
  h3 {
    color: #4e536a;
  }
}
.pass-notes {
  background-color: #e2f2ff;
  height: 326px;
  width: 100%;
  padding: 70px;
  border-radius: 15px;
  color: #4e536a;
  position: relative;

  .top-icon {
    position: absolute;
    top: -170px;
    right: 120px;
  }
}
</style>
